<template>
  <div :class="$style.confirmation">
    <div :class="$style.confirmation__body">
      <h3 :class="$style.confirmation__title">
        以下の内容で予約してよろしいですか？
      </h3>
      <div :class="$style.confirmation__content">
        <p :class="$style.confirmation__datetime">
          日時: {{ bookingDateTime }}
        </p>
      </div>
    </div>
    <div :class="$style.confirmation__actions">
      <FlatButton variant="secondary" @click="$emit('cancel')"
        >選びなおす</FlatButton
      >
      <FlatButton :disabled="isSubmitting" @click="$emit('confirm')"
        >予約確定</FlatButton
      >
    </div>
  </div>
</template>

<script setup lang="ts">
import FlatButton from '@/components/atoms/FlatButton.vue'
import { format } from 'date-fns'
import { ja } from 'date-fns/locale'
import { computed } from 'vue'
import type { TimeSlot } from './TimeSlotPicker/useTimeSlot.ts'

const props = defineProps<{
  timeSlot: TimeSlot
  isSubmitting: boolean
}>()

const bookingDateTime = computed(() => {
  const startsAt = format(new Date(props.timeSlot.startsAt), 'y/M/d (E) H:mm', {
    locale: ja,
  })
  const endsAt = format(new Date(props.timeSlot.endsAt), 'H:mm', { locale: ja })
  return `${startsAt} 〜 ${endsAt}`
})
</script>

<style lang="scss" module>
.confirmation {
  padding: 24px;
  background-color: $color-surface-primary;
  border-radius: $border-radius-inner;

  &__body {
    margin-bottom: 24px;
  }

  &__title {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 16px;
    color: $color-text-and-object-high-emphasis;
  }

  &__content {
    padding: 16px;
    background-color: $color-surface-secondary;
    border-radius: $border-radius-inner;
  }

  &__datetime {
    font-size: 18px;
    font-weight: bold;
    color: $color-text-and-object-accent-primary;
  }

  &__actions {
    display: flex;
    gap: 12px;
    justify-content: flex-start;
  }
}
</style>
